'use client';

import AppContext, { AppContextInfo } from '@/components/AppContext';
import theme from '@/theme';
import CssBaseline from '@mui/material/CssBaseline';
import { ThemeProvider } from '@mui/material/styles';
import { useState } from 'react';
import { AppI18NLanguageInfo } from './i18n/types';

interface ProvidersProps {
  languages: AppI18NLanguageInfo[];
  lng: string;
}

export default function Providers({
  children,
  lng: initialLng,
  languages,
}: React.PropsWithChildren<ProvidersProps>) {
  const [lng, setLang] = useState(initialLng);

  const app: AppContextInfo = {
    i18n: {
      lng,
      languages,
      setLang,
    },
  };

  return (
    <AppContext.Provider value={app}>
      <ThemeProvider theme={theme}>
        <CssBaseline enableColorScheme />
        {children}
      </ThemeProvider>
    </AppContext.Provider>
  );
}
